import {initialSupplementalSalaryState, ISupplementalSalaryState} from '@app/core/store/state/supplementalSalary.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {
	ESupplementalSalaryActions,
	SupplementalSalaryActions,
} from '@app/core/store/actions/supplementalSalary.actions';

export const supplementalSalaryReducers = (
	state = initialSupplementalSalaryState,
	action: SupplementalSalaryActions | ErrorActions,
): ISupplementalSalaryState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ESupplementalSalaryActions.GetSupplementalSalaries: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESupplementalSalaryActions.GetSupplementalSalariesSuccess: {
			return {
				...state,
				isLoading: false,
				supplementalSalaries: action.supplementalSalaries,
				pagination: action.pagination,
			};
		}
		case ESupplementalSalaryActions.PostSupplementalSalary: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESupplementalSalaryActions.PostSupplementalSalarySuccess: {
			return {
				...state,
				isLoading: false,
				supplementalSalaries: [action.supplementalSalary, ...state.supplementalSalaries],
			};
		}
		case ESupplementalSalaryActions.PatchSupplementalSalary: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESupplementalSalaryActions.PatchSupplementalSalarySuccess: {
			return {
				...state,
				isLoading: false,
				supplementalSalaries: state.supplementalSalaries.map(s => {
					if (s.id === action.supplementalSalary.id) {
						return action.supplementalSalary;
					}

					return s;
				}),
			};
		}
		case ESupplementalSalaryActions.DeleteSupplementalSalary: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESupplementalSalaryActions.DeleteSupplementalSalarySuccess: {
			return {
				...state,
				isLoading: false,
				supplementalSalaries: state.supplementalSalaries.filter(s => s.id !== action.supplementalSalary.id),
			};
		}
		case ESupplementalSalaryActions.GetSupplementalSalary: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESupplementalSalaryActions.GetSupplementalSalarySuccess: {
			return {
				...state,
				isLoading: false,
				selectedSupplementalSalary: action.supplementalSalary,
			};
		}
		case ESupplementalSalaryActions.ClearSupplementalSalaries: {
			return initialSupplementalSalaryState;
		}
		case ESupplementalSalaryActions.ClearEditingSupplementalSalary: {
			return {
				...state,
				selectedSupplementalSalary: undefined,
			};
		}
		default:
			return state;
	}
};
